module.exports = __webpack_public_path__ + "static/media/solutionSuccess.0a4fa4c8.jpg";